export default class BlockRoadTrip {
    constructor() {
        if (window.acf) {
            // Editor
            window.acf.addAction(
                'render_block_preview/type=iris-block-road-trip',
                BlockRoadTrip.callBlockService,
            )
        } else {
            // Frontend
            BlockRoadTrip.callBlockService()
        }
    }

    static callBlockService() {
        document.addEventListener('DOMContentLoaded', async () => {
            if ($('[data-id="road-trip-block"]').length > 0) {
                import(
                    '@blocks/road-trip/scripts/block' /* webpackChunkName: "scripts/road-trip-block" */
                ).then(({ default: Block }) => {
                    new Block()
                })
            }
        })
    }
}

new BlockRoadTrip()
